const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/artists/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/artists/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildArtistHubHead } from "@/features/artist-hub/artist-hub-head";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/$lang/artists/")({
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "artistHub"
    });
    return await buildArtistHubHead({
      locale,
      title: t("metaTitle"),
      description: t("metaDescription"),
      hub: loaderData?.hub
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});